import { CameraState } from '../implementations/Camera/types';
import { CNCMachineState } from '../implementations/CNCMachine/types';
import { CustomBaseState } from '../implementations/CustomBase/types';
import { CustomDeviceStateSchema } from '../implementations/CustomDevice/types/CustomDeviceState';
import { CustomGripperState } from '../implementations/CustomGripper/types';
import { CustomIOState } from '../implementations/CustomIO/types/CustomIOState';
import { EwellixLiftTLTState } from '../implementations/EwellixLiftTLT/types';
import { FTPServerState } from '../implementations/FTPServer/types';
import { GPUTaskRunnerState } from '../implementations/GPUTaskRunner/types';
import { HapticDeviceState } from '../implementations/HapticDevice/types';
import { InvalidConfigurationState } from '../implementations/InvalidConfiguration/types';
import { MiraiControllerState } from '../implementations/MiraiController/types';
import { ModbusTCPServerState } from '../implementations/ModbusTCPServer/types';
import { MountingAdapterState } from '../implementations/MountingAdapter/types';
import { MountingBracketState } from '../implementations/MountingBracket/types';
import { NoGripperState } from '../implementations/NoGripper/types';
import { OnRobot2FG14State } from '../implementations/onRobot/OnRobot2FG14/types';
import { OnRobot2FG7State } from '../implementations/onRobot/OnRobot2FG7/types';
import { OnRobot3FG15State } from '../implementations/onRobot/OnRobot3FG15/types';
import { OnRobotDualQuickChangerState } from '../implementations/onRobot/OnRobotDualQuickChanger/types';
import { OnRobotHexEState } from '../implementations/onRobot/OnRobotHexE/types';
import { OnRobotScrewdriverState } from '../implementations/onRobot/OnRobotScrewdriver/types';
import { OnRobotVGP20State } from '../implementations/onRobot/OnRobotVGP20/types';
import { Robotiq2FState } from '../implementations/robotiq/Robotiq2F/types';
import { RobotiqEPickState } from '../implementations/robotiq/RobotiqEPick/types';
import { RobotiqFT300State } from '../implementations/robotiq/RobotiqFT300/types';
import { RobotiqTSF85State } from '../implementations/robotiq/RobotiqTSF85/types';
import { S3BucketState } from '../implementations/S3Bucket/types';
import { SchunkEGxState } from '../implementations/schunk/SchunkEGx/types/SchunkEGxState';
import { StandardBotsRO1State } from '../implementations/StandardBotsRO1/types/StandardBotsRO1State';
import { EsabWeldMachineState } from '../implementations/WeldMachine/EsabWeldMachine/types/EsabWeldMachineState';
import { WeldMachineState } from '../implementations/WeldMachine/generic/types/WeldMachineState';
import { MillerWeldMachineState } from '../implementations/WeldMachine/MillerWeldMachine/types/MillerWeldMachineState';
import { WeldPositionerState } from '../implementations/WeldPositioner/types';
import { WristCameraState } from '../implementations/WristCamera/types';

/**
 * Device state is the current state of the device.
 */
export const DeviceStateRegistry = [
  MountingAdapterState,
  MountingBracketState,
  OnRobot2FG7State,
  OnRobot2FG14State,
  OnRobot3FG15State,
  OnRobotScrewdriverState,
  OnRobotDualQuickChangerState,
  OnRobotVGP20State,
  Robotiq2FState,
  RobotiqEPickState,
  CustomGripperState,
  CustomIOState,
  CustomBaseState,
  SchunkEGxState,
  NoGripperState,
  EwellixLiftTLTState,
  ModbusTCPServerState,
  FTPServerState,
  S3BucketState,
  WristCameraState,
  CNCMachineState,
  StandardBotsRO1State,
  WeldMachineState,
  MillerWeldMachineState,
  EsabWeldMachineState,
  CustomDeviceStateSchema,
  InvalidConfigurationState,
  OnRobotHexEState,
  RobotiqFT300State,
  GPUTaskRunnerState,
  CameraState,
  MiraiControllerState,
  HapticDeviceState,
  RobotiqTSF85State,
  WeldPositionerState,
] as const;
